import zhLocale from 'element-ui/lib/locale/lang/zh-CN'

const zh = {
  ...i18n_zh,
  ...zhLocale
}

export default zh;